export default __webpack_public_path__ + "assets/logo_full.a4b5f2a2.svg";